import OurProductsPage from '@modules/professional/page/OurProductsPage';
import type { MetaDescriptor } from 'react-router';
import { loader } from '@modules/professional/page/loaders/our-products-page-loader.server';
import { shouldRevalidateLeaf } from '~/modules/root/util/should-revalidate-leaf';
import { mergeMeta } from '~/modules/seo';
import type { APHandle } from '~/modules/root';

export const meta = mergeMeta<typeof loader>(
    () => {
        return [];
    },
    () => {
        const preloadImageLinks: MetaDescriptor[] = [];
        return [...preloadImageLinks];
    },
);

export const handle: APHandle = {
    category: 'product',
    hideContactArchiPro: true,
};

export { loader };
export const shouldRevalidate = shouldRevalidateLeaf;
export default OurProductsPage;
